import React, { useEffect, useRef, useState } from 'react';
import { GoogleMap, Marker } from '@react-google-maps/api';
import { mapStyle } from '../../utils/mapConstants';

// Shows the address as text; on hover, opens a small popup with the app's Google Map
// centered on the address (geocoded lazily on first hover, then cached). The Maps script
// is loaded globally in public/index.html, so window.google is available here.
const AddressMapPopup = ({ address }) => {
    const [open, setOpen] = useState(false);
    const [coords, setCoords] = useState(null);
    const [status, setStatus] = useState('idle'); // idle | loading | error
    const requestedRef = useRef(false);

    useEffect(() => {
        if (!open || requestedRef.current || !window.google?.maps) {
            return;
        }
        requestedRef.current = true;
        setStatus('loading');
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address }, (results, geoStatus) => {
            if (geoStatus === 'OK' && results && results[0]) {
                const loc = results[0].geometry.location;
                setCoords({ lat: loc.lat(), lng: loc.lng() });
                setStatus('idle');
            } else {
                setStatus('error');
            }
        });
    }, [open, address]);

    return (
        <span className="gw-addr" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
            <span className="gw-addr__text">{address}</span>
            {open ? (
                <span className="gw-addr__popup">
                    {coords ? (
                        <GoogleMap
                            mapContainerStyle={{ width: '260px', height: '180px' }}
                            center={coords}
                            zoom={15}
                            options={{ styles: mapStyle, disableDefaultUI: true, zoomControl: true, gestureHandling: 'greedy' }}
                        >
                            <Marker position={coords} />
                        </GoogleMap>
                    ) : (
                        <span className="gw-addr__msg">{status === 'error' ? "Couldn't locate this address" : 'Loading map…'}</span>
                    )}
                </span>
            ) : null}
        </span>
    );
};

export default AddressMapPopup;
